<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label"
    />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the radio group"
      [formField]="configForm.helpText"
    />
    <lib-signal-dropdown
      label="Orientation"
      [items]="orientationOptions"
      valuePath="value"
      displayPath="label"
      [value]="model().orientation"
      (valueChange)="updateOrientation($event)"
    />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Options
    </h3>
    <div class="flex flex-col gap-2">
      @for (option of model().options; track $index) {
        <div class="flex items-center gap-2">
          <lib-signal-text-field
            class="min-w-0 flex-1"
            label="Option"
            placeholder="Enter option"
            [formField]="configForm.options[$index]"
          />
          @if(model().options.length>2){
          <button type="button" class="shrink-0 text-xs text-red-500 mt-5 cursor-pointer"
                  (click)="removeOption($index)">
            Remove
          </button>
          }
        </div>
      }
      <button
        type="button"
        class="w-fit rounded-lg border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 my-2 cursor-pointer"
        (click)="addOption()">
        Add option
      </button>
    </div>
  </section>

  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>

    <lib-signal-checkbox
      label="Required"
      hint="Respondent must select an option"
      [formField]="configForm.required"
    />
  </section>
</form>
